export const QueryError = () => {
  return (
    <div
      className="row p-2"
      style={{ fontSize: "20px !important", justifyContent: "center" }}
    >
      <div>何かエラーがおきました</div>
    </div>
  );
};
